﻿(function (angular) {
  "use strict";

  var MAX_DEBUG_ID = 99999;

  var HTTP_OK = 200;

  angular.module("Toyota.Factories").factory("API", [
    "DebugLogger",
    "$http",
    "$q",
    function (DebugLogger, $http, $q) {
      // Query API and return JSON.
      function extendPromise(promise, extensions) {
        angular.extend(promise, extensions);

        var originalThen = promise.then;

        // preserve extensions above even when using .then()
        promise.then = function () {
          var originalThenResult = originalThen.apply(this, arguments);
          return extendPromise(originalThenResult, extensions);
        };

        return promise;
      }

      return {
        /*
         * WARNING: get() will lose its cancelability if you use $q.all or any
         * other $q methods that return a promise
         *
         * We really need to overhaul cancelable requests by migrating promises over to
         * tasks (see http://kriskowal.github.io/gtor/docs/task -- from the guy who
         * brought us the $q library in the first place)
         *
         */
        get: function (url, headers, cache) {
          var deferred = $q.defer();
          var httpTimeoutDeferred = $q.defer();
          httpTimeoutDeferred.promise.deferred = httpTimeoutDeferred; // support for HttpPendingRequestsService

          var debugId = "GET_" + Math.floor(Math.random() * MAX_DEBUG_ID) + "_" + url;

          DebugLogger.log("API", 'New "get" promise:', debugId);

          $http({ method: "GET", url: url, timeout: httpTimeoutDeferred.promise, headers: headers, cache: cache }).then(
            function (responseData) {
              if (responseData.ErrorMessage) {
                DebugLogger.log(
                  "API",
                  'Will reject "get" deferred -> reject "get" promise (response has ErrorMessage):',
                  debugId
                );
                deferred.reject(responseData, HTTP_OK);
              } else {
                DebugLogger.log("API", 'Will resolve "get" deferred -> resolve "get" promise:', debugId);
                deferred.resolve(responseData);
              }
            },
            function (responseData) {
              var failResult = {
                reason: responseData.data,
                status: responseData.status,
                ErrorMessage: responseData.status.toString(),
              };
              DebugLogger.log(
                "API",
                'Will reject "get" deferred -> reject "get" promise (hit $q fail branch):',
                debugId
              );
              deferred.reject(failResult);
              DebugLogger.log(
                "API",
                'Did reject "get" deferred -> reject "get" promise (hit $q fail branch):',
                debugId
              );
            }
          );

          var promiseExtensions = {
            debugId: debugId,
            _httpTimeout: httpTimeoutDeferred,
            cancel: function () {
              /*
               * Option to cancel request.
               *
               * This does not "really" cancel the promise but cancels the
               * underlying asynchronous requests by resolving deferred
               * promise stored in _httpTimeout.
               *
               */
              DebugLogger.log("API", 'Will cancel "get" promise -> reject "get" deferred:', deferred.promise.debugId);
              httpTimeoutDeferred.resolve();
              DebugLogger.log("API", 'Did cancel "get" promise -> reject "get" deferred:', deferred.promise.debugId);
            },
          };

          return extendPromise(deferred.promise, promiseExtensions);
        },

        all: function (promises) {
          var debugId = "ALL_" + Math.floor(Math.random() * MAX_DEBUG_ID);
          DebugLogger.log("API", 'New "all" promise:', debugId);

          var deferred = $q.defer();

          $q.all(promises).then(
            function (responseData) {
              DebugLogger.log(
                "API",
                'Will resolve "all" deferred -> resolve "all" promise:',
                deferred.promise.debugId,
                responseData
              );
              deferred.resolve(responseData);
            },
            function (responseData) {
              DebugLogger.log(
                "API",
                'Will reject "all" deferred -> reject "all" deferred:',
                deferred.promise.debugId,
                responseData
              );
              deferred.reject(responseData);
            }
          );

          var extensions = {
            debugId: debugId,
            cancel: function () {
              DebugLogger.log("API", "Will cancel $q.all promise children:", deferred.promise.debugId);

              promises.forEach(function (promise) {
                if (promise && promise.cancel) {
                  promise.cancel();
                }
              });

              DebugLogger.log("API", "Did cancel $q.all promise children:", deferred.promise.debugId);
            },
          };

          return extendPromise(deferred.promise, extensions);
        },

        post: function (url, postData, headers) {
          var deferred = $q.defer();

          // eslint-disable-next-line id-denylist
          $http({ method: "POST", url: url, data: postData, headers: headers }).then(
            function (successData) {
              if (successData.ErrorMessage) {
                deferred.reject(successData, HTTP_OK);
              } else {
                deferred.resolve(successData);
              }
            },
            function (failureData) {
              var failResult = {
                reason: failureData.data,
                status: failureData.status,
                ErrorMessage: failureData.status.toString(),
              };
              deferred.reject(failResult);
            }
          );

          return deferred.promise;
        },

        cancel: function (promise) {
          if (promise && promise.cancel) {
            // Just relay the cancel along to the "all" or "get" promise
            promise.cancel();
          }
        },

        getCancellablePromiseFromValue: function (value) {
          var deferred = $q.defer();
          deferred.resolve(value);

          return extendPromise(deferred.promise, {
            cancel: function () {
              DebugLogger.log("API", "Will cancel cancellable promise from value", value);
              deferred.reject("Cancellable promise from value has been cancelled");
              DebugLogger.log("API", "Did cancel cancellable promise from value", value);
            },
          });
        },
      };
    },
  ]);
})(window.angular);
